import { parseZonedDateTime, ZonedDateTime } from '@internationalized/date';
import { formatDateTimeStringToTimeZone, getTimeZonedDateString } from './date.helpers';

export const getTxCenterEtaZonedDateTime = (
  txEtaDate?: string | null,
  txEtaTime?: string | null,
  timezone?: string,
): ZonedDateTime | null => {
  const utcDate = getTimeZonedDateString(txEtaDate, txEtaTime, 'UTC');

  if (utcDate && timezone) {
    return parseZonedDateTime(utcDate);
  }

  return null;
};

export const getTxCenterEtaDateTime = (
  txEtaDate?: string | null,
  txEtaTime?: string | null,
  timezone?: string,
  format = 'M/dd/yyyy HH:mm',
): string | null => {
  const zonedUtcDate = getTxCenterEtaZonedDateTime(txEtaDate, txEtaTime, timezone);

  if (zonedUtcDate) {
    return formatDateTimeStringToTimeZone(zonedUtcDate.toAbsoluteString(), timezone, format);
  }

  return null;
};
